import Image from 'next/legacy/image';

export default function Customize() {
  return (
    <>
      <p>You can customise how the embed would look with the options on the left.</p>
      <Image src="/guides/customize-newsletter.jpg" width={1620} height={1994} alt="dashboard" />
    </>
  );
}
